import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-management-main',
  templateUrl: './user-management-main.component.html',
  styleUrls: ['./user-management-main.component.scss']
})
export class UserManagementMainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/user-management/user-management-main/user-management-main.component.ts